import { Directive, ElementRef, HostListener, Inject, Input, OnDestroy, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TooltipBaseDirective, TooltipPosition } from '@app/infrastructure/tooltips/tooltip-base';

@Directive({
	selector: '[appInfoTooltip]',
})
export class InfoTooltipDirective extends TooltipBaseDirective implements OnDestroy {
	@Input('appInfoTooltip') public tooltipTitle = '';
	@Input() public placement: TooltipPosition = 'top';
	@Input() public tooltipIsDisabled = false;

	constructor(public elementRef: ElementRef, public renderer: Renderer2, @Inject(DOCUMENT) public document: Document) {
		super();
	}

	@HostListener('mouseenter') public onMouseEnter(): void {
		if (!this.tooltip && !this.tooltipIsDisabled) {
			this.show();
			this.attachHandlers();
		}
	}

	@HostListener('mouseleave') public onMouseLeave(): void {
		if (this.tooltip) {
			this.hide();
			this.removeHandlers();
		}
	}

	public ngOnDestroy(): void {
		this.hide();
		this.removeHandlers();
	}
}
